import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';
import { getPublishedDate, resolveFeaturedImage } from './postUtils';

const BlogPostArticle = ({ blog }) => (
    <article className="blog-post-page">
        {resolveFeaturedImage(blog) ? (
            <div className="blog-post-hero">
                <img src={resolveFeaturedImage(blog)} alt={blog.featured_image_alt || blog.image_alt || blog.title} />
            </div>
        ) : null}

        <header className="blog-post-header">
            <h1>{blog.title}</h1>
            <p className="post_date">{getPublishedDate(blog)?.toDateString?.() || 'No publish date'}</p>
        </header>

        {blog.body_html ? (
            <div className="post_body markdown-body" dangerouslySetInnerHTML={{ __html: blog.body_html }} />
        ) : blog.body_markdown ? (
            <div className="post_body markdown-body">
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {blog.body_markdown}
                </ReactMarkdown>
            </div>
        ) : (
            <p className="post_body" dangerouslySetInnerHTML={{ __html: blog.body }} />
        )}

        <div className="blog-post-contact-callout">
            <p>Questions or thoughts? <Link to="/contact/">Contact me</Link>.</p>
        </div>
    </article>
);

export default BlogPostArticle;
